import React, { useEffect, useState } from "react";
import { Pressable, StyleSheet, View, Modal } from "react-native";
import { useSelector } from "react-redux";
import AddAddress from "@assets/svg/AddAddress";
import Cross from "@assets/svg/Cross";
import analytics from "@services/analytics";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { useNavigation } from "@react-navigation/native";
import CustomText from "../../components/CustomText";
import { LEADER_STATES } from "./ClPaymentAndAddress";

const ClAddressModal = () => {
  const navigation = useNavigation();
  const [isAddressAdded, setIsAddressAdded] = useState(true);
  // eslint-disable-next-line no-shadow
  const user = useSelector(({ auth: { user = {} } }) => user);

  useEffect(() => {
    setTimeout(() => {
      AsyncStorage.getItem("address_added").then((x) => {
        if (
          !JSON.parse(x) &&
          user.leader_state === LEADER_STATES.PAYMENT_DONE &&
          !user.address1
        ) {
          setIsAddressAdded(false);
        }
      });
    }, 1500);
  }, [user.address1, user.leader_state]);

  const closeModal = () => {
    setIsAddressAdded(true);
  };

  const handleModalVisibility = () => {
    setIsAddressAdded(true);
    analytics.trackEvent("Address modal clicked", {
      leader_state: user.leader_state,
      source: "modal",
    });
    navigation.navigate("TLAddress", {
      source: "payment_flow",
      fromCiAddressModal: true,
    });
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent
      visible={!isAddressAdded}
      animationType="fade"
    >
      <View style={styles.modalBackGround}>
        <View style={styles.modalContainer}>
          <Pressable
            testID="clam-modal-close"
            onPress={closeModal}
            style={{ alignSelf: "flex-end" }}
          >
            <Cross width={14} height={14} />
          </Pressable>
          <View style={{ alignItems: "center" }}>
            <AddAddress />
          </View>
          <View style={{ paddingLeft: 20, paddingBottom: 15, paddingTop: 32 }}>
            <CustomText
              style={{
                fontSize: 14,
                textAlign: "center",
              }}
            >
              कृपया अपना पता बताएं, जहाँ आप सामान की डिलीवरी चाहते हैं!
            </CustomText>
          </View>
          <Pressable
            testID="clam-modal-button"
            style={styles.submitModalButton}
            onPress={handleModalVisibility}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <CustomText
                variant="entityHeading"
                style={{ color: "white", marginBottom: 0 }}
              >
                अपना पता भरें
              </CustomText>
            </View>
          </Pressable>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  submitModalButton: {
    paddingVertical: 10,
    backgroundColor: "#E40046",
    borderRadius: 6,
    alignItems: "center",
    opacity: 1,
  },
  modalBackGround: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: "90%",
    backgroundColor: "white",
    padding: 20,
    justifyContent: "center",
    alignContent: "center",
    borderRadius: 10,
    elevation: 20,
  },
});

export default ClAddressModal;
